// Helper function to normalize Cognito Lambda error messages
const normalizeErrorMessage = (message: string) => {
  // Remove "PreAuthentication failed with error" or similar prefixes
  const match = message.match(/(\w+) failed with error (.+)/);
  if (match?.[2]) {
    return match[2];
  }
  return message;
};

// Helper function to safely extract error information
export interface ErrorInfo {
  name: string;
  message: string;
}

export function getErrorInfo(error: unknown): ErrorInfo {
  let name = 'UnknownError';
  let message = 'An unexpected error occurred';

  if (error instanceof Error) {
    name = error.name;
    message = error.message;
  } else if (error && typeof error === 'object') {
    // Check for __type property (Cognito error format)
    if ('__type' in error) {
      const err = error as Record<string, unknown>;
      name = typeof err.__type === 'string' ? err.__type : 'UnknownError';
      message = typeof err.message === 'string' ? err.message : 'An unexpected error occurred';
    }
    // Check for name and message properties (standard Error format)
    else if ('name' in error && 'message' in error) {
      const err = error as Record<string, unknown>;
      name = typeof err.name === 'string' ? err.name : 'UnknownError';
      message = typeof err.message === 'string' ? err.message : 'An unexpected error occurred';
    }
  }

  return {
    name,
    message: normalizeErrorMessage(message)
  };
}
